import React, { useEffect, useState } from "react";
import {
  Typography,
  Container,
  Dialog,
  Grid,
  TextField,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { DialogStyles } from "../../CommonComponents/Dialogs/DialogStyles";
import {
  checkIsNullUndefined,
  getErrorMessage,
  getScreenWidth,
} from "../../../commons/Utils";
import { CorreosButton } from "../../CorreosButton/CorreosButton";
import { PostSystemUserByUser, PostSystemUserByEnterprise } from "../../../services/ReasonService";
import { CommonStyles } from "../../../commons/CommonStyles";
import ReCAPTCHA from "react-google-recaptcha";

export function DialogCreate(props) {
  const { openCreate, setOpenCreate, finishOperation, idEnterprise, addSystemUser } = props;
  const dialogClasses = DialogStyles();
  const { t, i18n } = useTranslation();
  const commonClasses = CommonStyles();

  const [systemUserName, setSystemUserName] = useState("");
  const [circularProgress, setCircularProgress] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const [systemUserData, setSystemUserData] = useState({});

  const [reCaptchaToken, setReCaptchaToken] = useState(null);
  const [reCaptchaError, setReCaptchaError] = useState("");
  const [reCaptchaRef, setReCaptchaRef] = useState(null);

  const handleCancel = () => {
    setSystemUserName("");
    setSystemUserData({});
    setIsCreated(false);
    setOpenCreate(false);
  };

  const handleCreate = () => {
    setCircularProgress(true);
    let auxCall = checkIsNullUndefined(idEnterprise) ? PostSystemUserByUser : PostSystemUserByEnterprise;
    auxCall(systemUserName, reCaptchaToken, idEnterprise).then(
      (response) => {
        if (response && !response.Status) {
          setSystemUserData(response);
          addSystemUser(response);
          finishOperation("success", t("systemUserPageCreated"));
          setIsCreated(true);
        } else {
          finishOperation("error", getErrorMessage(response));
        }
        reCaptchaRef?.reset();
        setCircularProgress(false);
      }
    );
  };

  const handleOnChangeReCaptcha = (value) => {
    let auxRecaptchaToken = checkIsNullUndefined(value) ? null : value;
    if (!checkIsNullUndefined(value)) {
      setReCaptchaError("");
    }
    setReCaptchaToken(auxRecaptchaToken);
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(t("systemUserPageCreateClientId") + ": " + systemUserData.client_id + "\n" + t("systemUserPageCreateClientSecret") + ": " + systemUserData.client_secret).then(() => {
      finishOperation("success", t("systemUserPageClientSecretCopySuccess"));
    }).catch(err => {
      finishOperation("error", t("systemUserPageClientSecretCopyError"));
    });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={openCreate}
      onClose={handleCancel}
      PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
    >
      <Container className={dialogClasses.dialogTitle}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h4" className={dialogClasses.dialogTitleText}>
              {t("systemUserPageCreateTitle")}
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Container className={dialogClasses.dialogContainer}>
        <Grid container spacing={1}>
          {isCreated ? (
            <Grid item xs={12}>
              <Typography
                className={dialogClasses.dialogContentText}
                style={{ marginBottom: "1em" }}
              >
                {t("systemUserPageCreateData")}
              </Typography>
              <Grid item xs={12}>
                <Typography className={dialogClasses.dialogContentText}>
                  <b>{t("systemUserPageCreateClientId") + ": "}</b>
                  <span>{systemUserData.client_id}</span>
                </Typography>
                <Typography className={dialogClasses.dialogContentText}>
                  <b>{t("systemUserPageCreateClientSecret") + ": "}</b>
                  <span>{systemUserData.client_secret}</span>
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <Grid container item xs={12}>
              <Grid container item xs={12} style={{ marginBottom: "1em" }}>
                <Grid item xs={12} style={{ marginTop: "1em" }}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="idName"
                    label={t("systemUserPageCreateLabel")}
                    name="idName"
                    color="secondary"
                    onChange={(event) => setSystemUserName(event.target.value)}
                    value={systemUserName}
                    required
                  />
                </Grid>
              </Grid>
              <Grid
                item
                container
                justifyContent="center"
                xs={12}
                className={commonClasses.gridIdentity}
                style={{ marginBottom: "1em" }}
              >
                <Grid style={{ display: "inline-block", marginTop: "2em" }}>
                  <ReCAPTCHA
                    ref={(r) => setReCaptchaRef(r)}
                    sitekey={process?.env?.REACT_APP_RECAPTCHA_KEY}
                    onChange={handleOnChangeReCaptcha}
                    size={getScreenWidth() > 440 ? "normal" : "compact"}
                  />
                  {checkIsNullUndefined(reCaptchaError) ? null : (
                    <p
                      style={{
                        color: "#f32735",
                        fontSize: "80% !important",
                        textAlign: "start",
                      }}
                    >
                      {reCaptchaError}
                    </p>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid
            container
            item
            xs={12}
            className={dialogClasses.dialogButtonContainer}
          >
            <Grid item xs={6}>
              <CorreosButton
                onClick={handleCancel}
                className={dialogClasses.dialogButtonLeft}
              >
                {isCreated ? t("close") : t("cancel")}
              </CorreosButton>
            </Grid>
            <Grid item xs={6}>
              {isCreated ? (
                <CorreosButton
                  variant="contained"
                  color="primary"
                  onClick={handleCopyToClipboard}
                  className={dialogClasses.dialogButtonRight}
                >
                  {t("copy")}
                </CorreosButton>
              ) : (
                <CorreosButton
                  variant="contained"
                  color="primary"
                  onClick={handleCreate}
                  className={dialogClasses.dialogButtonRight}
                  circularProgress={circularProgress}
                  disabled={
                    checkIsNullUndefined(systemUserName) ||
                    checkIsNullUndefined(reCaptchaToken)
                  }
                >
                  {t("accept")}
                </CorreosButton>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
}
